import { useCallback } from "react"
import { useState } from "react"
import { useContext } from "react"
import { useEffect } from "react"
import { MdAdd, MdAddCircle, MdEdit } from "react-icons/md"
import { useParams } from "react-router-dom"
import Modal from "../../Components/Modal"
import Spinner from "../../Components/Spinner"
import UserContext from "../../Context/UserContext"
import { getEventDoc, getStaffWhereExhibitorAndEvent, updateExhibitor } from "../../Requests/firebaseFirestore"

export default function EventPage() {
  const [loading, setLoading] = useState(true)
  const [sending, setSending] = useState(false) 
  
  const {eventId} = useParams()
  const [event, setEvent] = useState({})
  const {user, seeAs} = useContext(UserContext)
  const [activeUser, setActiveUser] = useState(false)

  const [brands, setBrands] = useState([])
  const [newBrands, setNewBrands] = useState([])
  const [newBrand, setNewBrand] = useState('')
  
  const [staff, setStaff] = useState([])

  const [brandsModal, setBrandsModal] = useState(false)


  const handleBrandsModal = () => {
    setNewBrands(brands)
    setBrandsModal(!brandsModal)
  }

  const getInfo = useCallback(async()=>{
    setLoading(true)
    const ev = await getEventDoc(eventId)
    if(ev){
      setEvent(ev)
    }else{
      setEvent(false)
    }
    if(seeAs){
      setActiveUser(seeAs)
      let i
      seeAs.brands.forEach((brand, index)=>{
        if(brand.id===eventId){
          i = index
        }
      })
      setBrands([...seeAs.brands[i].brands])

      const stff = await getStaffWhereExhibitorAndEvent({id:seeAs.id, fullName:seeAs.fullName},{id:eventId, name:ev.name})
      
      setStaff([...stff])
    }else{
      setActiveUser({...user, id:user.uid})

      let i
      user.brands.forEach((brand, index)=>{
        if(brand.id===eventId){
          i = index
        }
      })
      setBrands([...user.brands[i].brands])

      const res = await getStaffWhereExhibitorAndEvent({id:user.uid, fullName:user.fullName},{id:eventId, name:ev.name})
      
      setStaff([...res])
    }
    setLoading(false)
  },[eventId])

  useEffect(()=>{
    getInfo()
  },[])

  const handleNewBrand = (e) => {
    e.preventDefault()
    if((newBrand!=='')&&(newBrands.indexOf(newBrand)===-1)){
      setNewBrands([...newBrands, newBrand].sort())
      setNewBrand('')
    }
  }

  const handleDeleteNewBrand = (brand) => {
    setNewBrands(newBrands.filter(brnd=>brnd!==brand))
  }

  const handleSaveNewBrands = async () => {
    setSending(true)
    let i
    activeUser.brands.forEach((brand, index)=>{
      if(brand.id===eventId){
        i = index
      }
    })
    let oldBrands = activeUser.brands
    oldBrands[i].brands = newBrands

    await updateExhibitor(activeUser.id, {brands:[...oldBrands]})
    setBrands([...newBrands])
    setSending(false) 
    setBrandsModal(false)
  }

  return <>
    {loading?
    <div className="mt-4">
      <Spinner/>
    </div>
    :
    <div className="container mx-auto px-4">
      {event?<>
      <h1 className="text-stone-600 font-semibold text-xl py-2">{event.name}</h1>
      <div className="flex flex-row items-center gap-4 text-lg mt-2">
        <button className="self-start" onClick={handleBrandsModal}><MdEdit size={25}/></button>
        <span className="self-start">Marcas:</span>
        <div className="flex flex-wrap">
          {brands.length===0?
          <span>No se indicaron marcas.</span>:
          <>
        {brands.map((brnd, i)=>{return(
          <span key={i} className='font-semibold px-2'>{brnd}</span>
          )})}
          </>}
        </div>
      </div>
        <h1 className="mt-4 text-xl font-semibold">Miembros de staff:</h1>
        {staff.length===0?
        <span>No tiene mienbros de staff.</span>:
        <>
        <table className=" mx-auto">
          <thead>
            <tr>
              <th className="px-4">Nombre</th>
              <th>Email</th>
            </tr>
          </thead>
          <tbody>
            {staff.map((stff, i)=>{return(
              <tr key={i} className='divide-x'>
                <td>
                  {stff.fullName}
                </td>
                <td className="px-4">
                  {stff.email}
                </td>
              </tr>
            )})}
          </tbody>
        </table>
            </>}
      </>:<>
      <h1 className="text-stone-600 font-semibold text-xl py-2">No se encontró el evento.</h1>
      </>}
    </div>
    }
    <Modal isActive={brandsModal} handle={handleBrandsModal} title='Editar marcas del evento'>
      <div className="flex flex-col gap-4 px-[12%]">
          <form className="flex gap-4" onSubmit={handleNewBrand}>
            <input type="text" name="" id="" placeholder="Agregar marca" onChange={(e)=>{setNewBrand(e.target.value)}} value={newBrand}/>
            <button className="action-btn"><MdAdd size={25}/></button>
          </form>
        <div className="flex flex-wrap justify-center text-lg gap-4">
        {newBrands.map((brnd, i)=>{return(
          <button key={i} className='hover:line-through' onClick={()=>{handleDeleteNewBrand(brnd)}}>{brnd}</button>
        )})}
        </div>
        <button className="send-btn" onClick={handleSaveNewBrands} disabled={sending}>{sending?'Guardando...':'Guardar cambios'}</button>
      </div>
    </Modal>
    </>
}